<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_6"><a id="PART1"></a> PART I</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_007.vue?af29f67c